export default __webpack_public_path__ + "static/media/sass.aa16d644.png";